



































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getPopWindowTemplateList, getPopWindowTemplateTagList } from "@/services/api";
import { isTieredDiscountTemplateGray } from "@/utils/experiment";
import questionIcon from "@/assets/img/icon/question.svg";
import newTagIcon from "@/assets/img/new_tag.svg";

interface TemplateTagOption {
  id: number;
  name: string;
  tagType: string;
  sortNumber?: number;
}

interface TemplateTypeOption {
  label: string;
  value: number;
}

interface TemplateItem {
  id: number;
  type: number;
  name: string;
  previewImage: string;
  isShow: boolean;
  newTemplate?: boolean;
  tagList?: TemplateTagOption[];
}

interface TemplateListParams {
  companyId: number | null;
  triggerEventType: number;
  keyword?: string;
  displayTypeTagIds?: number[];
  themeTagIds?: number[];
  industryTagIds?: number[];
  sortType?: string;
}

const FORM_TEMPLATE_TAG_TYPES = ["display_type", "theme", "industry"];
const TEMPLATE_CARD_VIEW_DURATION = 1000;
const KEYWORD_FILTER_DELAY = 500;

@Component({})
export default class TemplateSelectDialog extends Vue {
  @Prop({ default: false })
  visible!: boolean;

  @Prop({ default: null })
  companyId!: number | null;

  @Prop({ default: () => [0] })
  tabAuthList!: number[];

  /** 打开弹窗时默认选中的场景 tab（triggerEventType） */
  @Prop({ default: null })
  defaultTriggerEventType!: number | null;

  /** 打开并加载模板后自动选中第一个模板并触发创建 */
  @Prop({ default: false })
  autoCreateOnOpen!: boolean;

  activeType = "0";
  createList: TemplateItem[] = [];
  templateFilterSourceList: TemplateItem[] = [];
  displayTypeTagOptions: TemplateTagOption[] = [];
  themeTagOptions: TemplateTagOption[] = [];
  industryTagOptions: TemplateTagOption[] = [];
  createListIndex = -1;
  selectedTemplate: TemplateItem | null = null;
  isTemplateLoading = false;
  questionIconSrc = questionIcon;
  newTagIconSrc = newTagIcon;
  filters = this.getDefaultFilters();
  templateCardObserver: IntersectionObserver | null = null;
  templateCardViewTimers: Map<number, number> = new Map();
  viewedTemplateIds: Set<number> = new Set();
  keywordFilterTimer: number | null = null;
  /** 推荐入口自动创建前，模板库停留时长，避免一闪而过 */
  autoCreateTimer: number | null = null;
  static readonly AUTO_CREATE_DELAY_MS = 2000;

  get typeOptions(): TemplateTypeOption[] {
    return [
      { label: this.$tx("form.template.tab.0", "新用户订阅弹窗"), value: 0 },
      { label: this.$tx("form.template.tab.1", "退出意图挽留弹窗"), value: 1 },
      { label: this.$tx("form.template.tab.2", "新用户加购订阅弹窗"), value: 2 },
      { label: this.$tx("form.template.tab.3", "邮件/短信承接弹窗"), value: 3 },
      { label: this.$tx("form.template.tab.4", "老用户召回弹窗"), value: 4 },
      { label: this.$tx("form.template.tab.5", "弃单挽留弹窗"), value: 5 },
      { label: this.$tx("form.template.tab.6", "到货提醒弹窗"), value: 6 },
      { label: this.$tx("form.template.tab.7", "嵌入式表单"), value: 7 },
      { label: this.$tx("form.template.tab.8", "自定义触发表单"), value: 8 }
    ];
  }

  get visibleTypeOptions() {
    return this.typeOptions.filter((item) => this.tabAuthList.includes(item.value));
  }

  get showTemplateFilter() {
    return this.templateFilterSourceList.length > 8;
  }

  @Watch("visible")
  onVisibleChange(value: boolean) {
    if (value) {
      this.handleOpen();
    } else {
      this.teardownTemplateCardObserver();
    }
  }

  getDefaultFilters() {
    return {
      keyword: "",
      displayTypeTagIds: [] as number[],
      themeTagIds: [] as number[],
      industryTagIds: [] as number[],
      sortType: "recommend"
    };
  }

  async handleOpen() {
    this.isTemplateLoading = true;
    this.resetTemplateCardViewTracking();
    if (this.defaultTriggerEventType != null) {
      const preferredType = `${this.defaultTriggerEventType}`;
      if (this.visibleTypeOptions.some((item) => `${item.value}` === preferredType)) {
        this.activeType = preferredType;
      }
    }
    const firstType = this.visibleTypeOptions[0]?.value;
    if (!this.visibleTypeOptions.some((item) => `${item.value}` === `${this.activeType}`) && firstType !== undefined) {
      this.activeType = `${firstType}`;
    }
    this.resetTemplateFilters();
    await this.loadTemplateFilterOptions();
    await this.loadCreateTemplates(true);
    if (this.autoCreateOnOpen) {
      this.tryAutoCreateFromRecommend();
    }
  }

  tryAutoCreateFromRecommend() {
    if (!this.selectedTemplate) {
      this.$message.warning(this.$tx('form.list.noTemplate', '当前暂无可用模板'));
      this.handleClose();
      return;
    }
    this.clearAutoCreateTimer();
    // 推荐入口：模板库选中首个模板后停留 2s，再进入创建页
    this.autoCreateTimer = window.setTimeout(() => {
      this.autoCreateTimer = null;
      if (!this.visible || !this.selectedTemplate) {
        return;
      }
      this.createToRoute();
      this.handleClose();
    }, TemplateSelectDialog.AUTO_CREATE_DELAY_MS);
  }

  clearAutoCreateTimer() {
    if (this.autoCreateTimer == null) {
      return;
    }
    window.clearTimeout(this.autoCreateTimer);
    this.autoCreateTimer = null;
  }

  resetTemplateFilters() {
    this.clearKeywordFilterTimer();
    this.filters = this.getDefaultFilters();
  }

  getTemplateListParams(withFilter: boolean) {
    const params: TemplateListParams = {
      companyId: this.companyId,
      triggerEventType: Number(this.activeType)
    };
    if (!withFilter) {
      return params;
    }
    if (!this.showTemplateFilter) {
      return params;
    }
    if (this.filters.keyword.trim()) {
      params.keyword = this.filters.keyword.trim();
    }
    if (this.filters.displayTypeTagIds.length) {
      params.displayTypeTagIds = this.filters.displayTypeTagIds;
    }
    if (this.filters.themeTagIds.length) {
      params.themeTagIds = this.filters.themeTagIds;
    }
    if (this.filters.industryTagIds.length) {
      params.industryTagIds = this.filters.industryTagIds;
    }
    params.sortType = this.filters.sortType;
    return params;
  }

  normalizeTemplateList(list: TemplateItem[] = []) {
    return list.filter((item: TemplateItem) => {
      if (item.id === 210 && !isTieredDiscountTemplateGray()) {
        return false;
      }
      return true;
    });
  }

  updateTemplateSelection() {
    const firstTemplate = this.createList.find((item: TemplateItem) => item.isShow);
    if (!firstTemplate) {
      this.createListIndex = -1;
      this.selectedTemplate = null;
      return;
    }
    this.createListIndex = this.createList.indexOf(firstTemplate);
    this.selectedTemplate = firstTemplate;
  }

  async loadCreateTemplates(showLoading = true) {
    this.isTemplateLoading = true;
    this.teardownTemplateCardObserver();
    try {
      const { data, status } = await getPopWindowTemplateList(this.getTemplateListParams(true), showLoading);
      if (status === 200) {
        this.createList = this.normalizeTemplateList((data.data || []) as TemplateItem[]);
        this.updateTemplateSelection();
      }
    } finally {
      this.isTemplateLoading = false;
      // 等 loading 占位切回模板列表后再注册曝光监听，保证首屏卡片能被 observer 捕获。
      this.$nextTick(() => {
        this.setupTemplateCardObserver();
      });
    }
  }

  async loadTemplateFilterOptions() {
    const [templateResponse, tagResponse] = await Promise.all([
      getPopWindowTemplateList(this.getTemplateListParams(false), false),
      getPopWindowTemplateTagList({ tagTypes: FORM_TEMPLATE_TAG_TYPES }, false)
    ]);
    if (templateResponse.status === 200) {
      this.templateFilterSourceList = this.normalizeTemplateList((templateResponse.data.data || []) as TemplateItem[]);
    }
    const tagList = tagResponse.status === 200 ? ((tagResponse.data.data || []) as TemplateTagOption[]) : [];
    if (tagList.length) {
      // 筛选项优先使用后端独立标签接口，避免依赖当前模板关联关系。
      this.displayTypeTagOptions = this.getTagOptionsFromList(tagList, "display_type");
      this.themeTagOptions = this.getTagOptionsFromList(tagList, "theme");
      this.industryTagOptions = this.getTagOptionsFromList(tagList, "industry");
      return;
    }
    this.displayTypeTagOptions = this.getTemplateTagOptions("display_type");
    this.themeTagOptions = this.getTemplateTagOptions("theme");
    this.industryTagOptions = this.getTemplateTagOptions("industry");
  }

  getTagOptionsFromList(tagList: TemplateTagOption[], tagType: string) {
    const tagMap = new Map<number, TemplateTagOption>();
    tagList.forEach((tag: TemplateTagOption) => {
      if (tag.tagType === tagType && !tagMap.has(tag.id)) {
        tagMap.set(tag.id, tag);
      }
    });
    return Array.from(tagMap.values()).sort((a, b) => (b.sortNumber || 0) - (a.sortNumber || 0));
  }

  getTemplateTagOptions(tagType: string) {
    const tagMap = new Map<number, TemplateTagOption>();
    this.templateFilterSourceList.forEach((template: TemplateItem) => {
      (template.tagList || []).forEach((tag: TemplateTagOption) => {
        if (tag.tagType === tagType && !tagMap.has(tag.id)) {
          tagMap.set(tag.id, tag);
        }
      });
    });
    return Array.from(tagMap.values()).sort((a, b) => (b.sortNumber || 0) - (a.sortNumber || 0));
  }

  async handleTypeChange() {
    this.isTemplateLoading = true;
    this.createList = [];
    this.resetTemplateFilters();
    // 当前场景模板数不超过 8 个时不展示筛选，先加载未筛选列表用于判断。
    await this.loadTemplateFilterOptions();
    await this.loadCreateTemplates(true);
  }

  async handleFilterChange(filterDimension: string) {
    await this.loadCreateTemplates(true);
    this.trackTemplateFilterChange(filterDimension);
  }

  handleKeywordInput() {
    this.clearKeywordFilterTimer();
    // 输入过程中延迟触发搜索，减少连续输入时的模板列表请求。
    this.keywordFilterTimer = window.setTimeout(() => {
      this.keywordFilterTimer = null;
      this.handleFilterChange("keyword");
    }, KEYWORD_FILTER_DELAY);
  }

  handleKeywordEnter() {
    this.clearKeywordFilterTimer();
    this.handleFilterChange("keyword");
  }

  handleKeywordClear() {
    this.clearKeywordFilterTimer();
    this.handleFilterChange("keyword");
  }

  clearKeywordFilterTimer() {
    if (!this.keywordFilterTimer) {
      return;
    }
    window.clearTimeout(this.keywordFilterTimer);
    this.keywordFilterTimer = null;
  }

  async handleSortChange() {
    await this.loadCreateTemplates(true);
    this.trackTemplateSortChange();
  }

  refreshTemplateList() {
    this.loadCreateTemplates(true);
  }

  async clearTemplateFilters() {
    this.resetTemplateFilters();
    await this.loadCreateTemplates(true);
    this.trackTemplateFilterChange("all");
  }

  viewAllTemplates() {
    this.clearTemplateFilters();
  }

  createClick(item: TemplateItem, index: number) {
    if (item.isShow) {
      this.selectedTemplate = item;
      this.createListIndex = index;
    }
  }

  createToRoute() {
    if (!this.selectedTemplate) {
      return;
    }
    this.$emit("create", this.selectedTemplate);
  }

  catalogName(name: string, kind: 'template' | 'tag' = 'template') {
    if (!name) {
      return '';
    }
    return this.$tx(`form.catalog.${kind}.${name}`, name);
  }

  showCombinationTypeTemplate(tempId: number) {
    const companyInfo = JSON.parse(localStorage.getItem("companyInfo") || "{}") as { id?: number };
    const companyId = companyInfo.id;
    if (`${tempId}` !== "40" && `${tempId}` !== "41") {
      return true;
    }
    return (`${tempId}` === "40" || `${tempId}` === "41") && (companyId === 30 || companyId === 563 || companyId === 565 || companyId === 577 || companyId === 578 || companyId === 579 || companyId === 580 || companyId === 581 || companyId === 582 || companyId === 680 || companyId === 681 || companyId === 441 || companyId === 920 || companyId === 1039 || companyId === 907);
  }

  handleClose() {
    this.clearAutoCreateTimer();
    this.clearKeywordFilterTimer();
    this.teardownTemplateCardObserver();
    this.$emit("update:visible", false);
  }

  trackTemplateFilterChange(filterDimension: string) {
    const companyInfo = JSON.parse(localStorage.getItem("companyInfo") || "{}");
    const displayInfo = JSON.parse(localStorage.getItem("displayInfo") || "{}");
    window?.gtagNew?.("event", "form_create_templateFilterChange", {
      event_name: "弹窗_创建订阅工具_查看模板库_模板筛选条件变更",
      event_type: "按钮点击",
      filterDimension,
      Company_id: companyInfo?.id,
      login_id: displayInfo?.id,
      login_type: displayInfo?.innerUserType,
      path_url: window.location.href,
      time: new Date()
    });
  }

  trackTemplateSortChange() {
    const companyInfo = JSON.parse(localStorage.getItem("companyInfo") || "{}");
    const displayInfo = JSON.parse(localStorage.getItem("displayInfo") || "{}");
    window?.gtagNew?.("event", "form_create_templateSortChange", {
      event_name: "弹窗_创建订阅工具_查看模板库_模板排序变更",
      event_type: "按钮点击",
      Company_id: companyInfo?.id,
      login_id: displayInfo?.id,
      login_type: displayInfo?.innerUserType,
      path_url: window.location.href,
      time: new Date()
    });
  }

  trackTemplateCardView(templateId: number) {
    const companyInfo = JSON.parse(localStorage.getItem("companyInfo") || "{}");
    const displayInfo = JSON.parse(localStorage.getItem("displayInfo") || "{}");
    window?.gtagNew?.("event", "form_create_templateCardView", {
      event_name: "弹窗_创建订阅工具_模板卡片曝光",
      event_type: "页面曝光",
      templateId,
      Company_id: companyInfo?.id,
      login_id: displayInfo?.id,
      login_type: displayInfo?.innerUserType,
      path_url: window.location.href,
      time: new Date()
    });
  }

  setupTemplateCardObserver() {
    this.teardownTemplateCardObserver();
    const wrapper = this.getVisibleTemplateWrapper();
    const cardList = this.getVisibleTemplateCards(wrapper);
    if (!cardList.length || typeof IntersectionObserver === "undefined") {
      return;
    }
    this.templateCardObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const target = entry.target as HTMLElement;
          const templateId = Number(target.dataset.templateId);
          if (!templateId || this.viewedTemplateIds.has(templateId)) {
            return;
          }
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            this.startTemplateCardViewTimer(templateId);
            return;
          }
          this.clearTemplateCardViewTimer(templateId);
        });
      },
      {
        root: wrapper,
        threshold: [0, 0.5, 1]
      }
    );
    cardList.forEach((card) => {
      const templateId = Number(card.dataset.templateId);
      if (templateId && !this.viewedTemplateIds.has(templateId)) {
        this.templateCardObserver?.observe(card);
      }
    });
    // 首屏卡片注册 observer 后已处于可见状态时，主动补一次可见性判断。
    window.requestAnimationFrame(() => {
      this.checkVisibleTemplateCards(wrapper);
    });
  }

  getVisibleTemplateWrapper() {
    const wrapperList = Array.from(this.$el.querySelectorAll(".dialog-item-wrapper")) as HTMLElement[];
    return wrapperList.find((wrapper) => {
      const rect = wrapper.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }) || null;
  }

  getVisibleTemplateCards(wrapper: HTMLElement | null) {
    if (!wrapper) {
      return [];
    }
    return (Array.from(wrapper.querySelectorAll(".dialog-item")) as HTMLElement[]).filter((card) => {
      const rect = card.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    });
  }

  checkVisibleTemplateCards(wrapper: HTMLElement | null) {
    this.getVisibleTemplateCards(wrapper).forEach((card) => {
      const templateId = Number(card.dataset.templateId);
      if (!templateId || this.viewedTemplateIds.has(templateId)) {
        return;
      }
      if (this.getTemplateCardVisibleRatio(card, wrapper) >= 0.5) {
        this.startTemplateCardViewTimer(templateId);
      }
    });
  }

  getTemplateCardVisibleRatio(card: HTMLElement, wrapper: HTMLElement | null) {
    const cardRect = card.getBoundingClientRect();
    const rootRect = wrapper?.getBoundingClientRect() || {
      top: 0,
      left: 0,
      right: window.innerWidth,
      bottom: window.innerHeight
    };
    const visibleWidth = Math.max(0, Math.min(cardRect.right, rootRect.right) - Math.max(cardRect.left, rootRect.left));
    const visibleHeight = Math.max(0, Math.min(cardRect.bottom, rootRect.bottom) - Math.max(cardRect.top, rootRect.top));
    const cardArea = cardRect.width * cardRect.height;
    if (!cardArea) {
      return 0;
    }
    return (visibleWidth * visibleHeight) / cardArea;
  }

  startTemplateCardViewTimer(templateId: number) {
    if (this.templateCardViewTimers.has(templateId)) {
      return;
    }
    const timer = window.setTimeout(() => {
      this.templateCardViewTimers.delete(templateId);
      if (this.viewedTemplateIds.has(templateId)) {
        return;
      }
      const wrapper = this.getVisibleTemplateWrapper();
      const card = this.getVisibleTemplateCards(wrapper).find((item) => Number(item.dataset.templateId) === templateId);
      if (!card || this.getTemplateCardVisibleRatio(card, wrapper) < 0.5) {
        return;
      }
      this.viewedTemplateIds.add(templateId);
      this.trackTemplateCardView(templateId);
    }, TEMPLATE_CARD_VIEW_DURATION);
    this.templateCardViewTimers.set(templateId, timer);
  }

  clearTemplateCardViewTimer(templateId: number) {
    const timer = this.templateCardViewTimers.get(templateId);
    if (!timer) {
      return;
    }
    window.clearTimeout(timer);
    this.templateCardViewTimers.delete(templateId);
  }

  teardownTemplateCardObserver() {
    this.templateCardObserver?.disconnect();
    this.templateCardObserver = null;
    this.templateCardViewTimers.forEach((timer) => {
      window.clearTimeout(timer);
    });
    this.templateCardViewTimers.clear();
  }

  resetTemplateCardViewTracking() {
    this.viewedTemplateIds.clear();
    this.teardownTemplateCardObserver();
  }

  beforeDestroy() {
    this.clearKeywordFilterTimer();
    this.teardownTemplateCardObserver();
  }
}
